import { Grid } from './Grid';
import { Header } from './Header';
import { TaskList } from './TaskList';

export const Day = { Grid, Header, TaskList };
